import { ReactElement } from "react";

export default function Show(props: { hasAccess: boolean; children: ReactElement }) {
    return (<>{props.hasAccess
        ? (props.children)
        : (<></>)
    }</>)
}
